module.exports = __webpack_public_path__ + "img/x8.71fa0478.jpg";